import { Carousel } from 'nuka-carousel';

export const CustomSlider = ({ responsive, body }) => {
    return (
        <>
            <Carousel responsive={responsive}>{body}</Carousel>
        </>
    );
};
